import { connect } from "react-redux";
import UpdateDishFiles from "./UpdateDishFiles";
import { updateItemFiles } from "../../../../../redux/actions/venue";

const mapDispatchToProps = {
  updateItemFilesAction: updateItemFiles,
};

export default connect(null, mapDispatchToProps)(UpdateDishFiles);
